export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/LocationIcon.c1f3805a.svg","height":16,"width":12,"blurWidth":0,"blurHeight":0};